<template>
	<TrialEndDialog
		@schedule="onSchedule"
		@chat="onChat"
		@subscribe="onSubscribe"
	/>
</template>

<script>
import { foundation } from "@teaming/slice-engine";
import { TelemetryLocation } from "@teaming/common-enums";
import { TrialEndDialog } from "@teaming/common-ui";

export default {
	name: "TrialEndDialogHOC",
	components: {
		TrialEndDialog,
	},
	inject: [ "userProfile", ],
	computed: {
	},
	methods: {
		onSchedule() {
			foundation().navigation.navigateToCoaching();
		},
		onChat() {
			foundation().telemetry._intercom.show();
		},
		onSubscribe() {
			const { personId, email, } = this.userProfile;
			foundation().navigation.navigateToStripePayment( {
				personId,
				email,
				location: TelemetryLocation.TRIAL_END_DIALOG,
			} );
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
